<template>
  <v-list-item v-if="item" class="machine-list-item" lines="two" density="compact" :title="machineGeneralizerText(item)"
    @click="onRowClick">
    <template v-if="showAlerts || !hideImage" #prepend>
      <div class="d-flex align-start ga-2 flex-shrink-0 machine-list-item__prepend">
        <div v-if="showAlerts" class="d-flex flex-column justify-center align-start machine-list-item__alerts">
          <v-tooltip v-if="item.ActiveServiceJobs" location="end">
            <template #activator="{ props: tipProps }">
              <v-chip v-bind="tipProps" size="x-small" color="#8a55f6" variant="flat"
                class="machine-list-item__alert-chip text-white">
                {{ item.ActiveServiceJobs }}
                <v-icon size="14" class="ml-1" icon="mdi-alert" />
                <v-icon size="14" icon="mdi-briefcase" />
              </v-chip>
            </template>
            <span>{{ item.ActiveServiceJobs }} open service orders</span>
          </v-tooltip>

          <v-tooltip v-if="item.ActivePartsJobs" location="end">
            <template #activator="{ props: tipProps }">
              <v-chip v-bind="tipProps" class="mt-1 machine-list-item__alert-chip text-white" size="x-small"
                color="#e955f6" variant="flat">
                {{ item.ActivePartsJobs }}
                <v-icon size="14" class="ml-1" icon="mdi-alert" />
                <v-icon size="14" icon="mdi-tag" />
              </v-chip>
            </template>
            <span>{{ item.ActivePartsJobs }} open part orders</span>
          </v-tooltip>
        </div>

        <MachineModelImage v-if="!hideImage" :size="40" :relative-path="modelImagePath" class="flex-shrink-0 mr-2" />
      </div>
    </template>

    <template #subtitle>
      <span class="text-primary">{{ machineIdentifierText(item) }}</span>
    </template>

    <template #append>
      <slot name="actions">
        <v-btn v-if="showOpenBtn" icon="mdi-chevron-right" variant="text" size="small" :aria-label="$t('text.open')"
          @click.stop="openMachine(item)" />
      </slot>
    </template>
  </v-list-item>
</template>

<script>
import MachineModelImage from "@/components/Cards/MachineModelImage.vue";

export default {
  name: "MachineListItem",
  props: {
    item: Object,
    hideImage: Boolean,
    showAlerts: Boolean,
    showOpenBtn: Boolean,
  },
  components: {
    MachineModelImage,
  },

  computed: {
    modelImagePath() {
      if (!this.item) return undefined;
      return this.item.ModelImage || (this.item.MachineModel && this.item.MachineModel.ModelImage);
    },
  },

  methods: {
    onRowClick(e) {
      this.$emit("click", e);
    },

    openMachine(machine) {
      this.$router.push({ name: "ViewMachine", params: { id: machine.Id } });
    },
  },
};
</script>

<style scoped>
.machine-list-item__alerts {
  min-width: 70px;
  height: unset;
}

.machine-list-item__alert-chip {
  border-radius: 4px;
  width: fit-content;
}
</style>
